export enum AddressBookRouteNames {
  CustomerOrganizations = "customerOrganizations",
  CustomerPersons = "customerPersons",
  CustomerPerson = "customerPerson",
}
